import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companies: [],
            showArchived: false,
            showVersionConfig: false,
            newVersionNumber: null,
            androidUpdateVersion: true,
            huaweiUpdateVersion: true,
            iosUpdateVersion: true,
            filter: ''
        }
    },
    computed : {
        filteredCompany : function () {
            return this.companies.filter(item =>
                item.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1 ||
                item.displayName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
            )
        },
    },
    methods: {
        load: load,
        editCompany: editCompany,
        invoices: invoices,
        createInvoiceForCompanyOrAll: createInvoiceForCompanyOrAll,
        openInvoiceReport: openInvoiceReport,
        addCompany: addCompany,
        translateCompany: translateCompany,
        configCompany: configCompany,
        deleteCompany: deleteCompany,
        updateVersions: updateVersions,
        unarchiveCompany: unarchiveCompany,
        getApyKey: getApyKey,
        keymonitor: keymonitor,
        doorConfigCompany: doorConfigCompany
    },

    watch: {
        showArchived: function (val, old) {
            this.load();
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load()
    }
}


function load() {
    let _self = this;

    AdminApiService.getCompanies(this.showArchived)
        .then((response) => {
            _self.companies = response.data
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })


}

function createInvoiceForCompanyOrAll(companyName) {
    let _self = this;
    if (companyName == null) {
        swal({
            title: LocService.t('label_are_you_sure'),
            text: LocService.t('label_invoice_create_all_confirm'),
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: LocService.t('label_no'),
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: LocService.t('label_yes'),
            customClass: 'swal2-warning'
        }).then(function () {
            executeInvoiceCreate(_self, companyName);
        });
        return;
    }

    executeInvoiceCreate(this, companyName);
}

function executeInvoiceCreate(vm, companyName) {
    let _self = vm;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.createAllInvoiceOrForCompany(companyName)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_invoices_created_successfully'), 'success')
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function invoices(company){
    this.$router.push('/invoices?companyName=' + company.name)
}

function editCompany(company) {
    this.$router.push('/edit-company?id=' + company.id)
}

function addCompany() {
    this.$router.push('/add-company')
}

function openInvoiceReport() {
    this.$router.push('/invoice-report')
}

function translateCompany(company) {
    this.$router.push('/translations?companyName=' + company.name)
}

function configCompany(company) {
    this.$router.push('/config-company?id=' + company.id + '&name=' + company.name)
}

function doorConfigCompany(company){
    this.$router.push('/door-config?id=' + company.id + '&name=' + company.name)
}

function deleteCompany(item){
    if(this.showArchived){
        this.unarchiveCompany(item);
        return;
    }
    let _self = this;
    swal({
        title:  "Da li ste sigruni?",
        text:  "Da li ste sigruni da zelite da obrisete kompaniju: " + item.name + " ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteCompanies(item.id)
            .then((response) => {
                swal('Success', 'Uspešno obrisana kompanija', 'success')
                _self.load();
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });

}

function unarchiveCompany(item){
    let _self = this;
    swal({
        title:  "Da li ste sigruni?",
        text:  "Da li ste sigruni da zelite da povratite kompaniju: " + item.name + " ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.unarchiveCompany(item.id)
            .then((response) => {

                swal('Success', 'Uspešno obrisana kompanija', 'success')
                _self.load();
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function getApyKey(id){
    let _self = this;
    AdminApiService.getCompanyApiKey(id)
        .then((response) => {
            const apiKey = response.data.apiKey;
            navigator.clipboard.writeText(apiKey)
                .then(() => {
                    swal('Success - kopiran api key', apiKey, 'success')
                })
                .catch(err => {
                    swal('Success', apiKey, 'success')
                    console.error("Greška pri kopiranju: ", err);
                });

        })
        .catch(error => {
            console.log(error)
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function updateVersions(){
    let _self = this;
    if(this.newVersionNumber == null || this.newVersionNumber === 0) return
    var versions = [];
    if(this.androidUpdateVersion){
        versions.push("ANDROID")
    }
    if(this.huaweiUpdateVersion){
        versions.push("HUAWEI")
    }
    if(this.iosUpdateVersion){
        versions.push("IOS")
    }
    let model = {
        applicationTypes: versions,
        versionCode: this.newVersionNumber,
        companyIds: this.filteredCompany.map(c => c.id)
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.updateVersions(model)
        .then((response) => {
            swal('Success', 'Uspešno azurirane verzije', 'success')
            _self.newVersionNumber = null;
            _self.androidUpdateVersion = true;
            _self.huaweiUpdateVersion = true;
            _self.iosUpdateVersion = true;
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Company/Company.js